.social {
  display: flex;
  gap: 1rem;
  justify-content: center;
  height: 2rem;
  width: 112px;
}

.social__icon {
  height: 100%;

  &:hover {
    transform: scale(1.05);
    opacity: 0.8;
  }
}
